<div class="content" title="{{ filename }}">
  <div class="icon" [ngClass]="getClassName()"></div>
  <div class="info">
    <span class="fileName">{{ filename }}</span>
    <span class="fileSize">{{ getFileExtension() }} · {{ size | fileSize }}</span>
  </div>
</div>
